import axios from 'axios';
import {showAlert} from './alerts';


export const resetPassword = async (resetToken, newPassword, newPasswordConfirm) => {
    try {

        const {data} = await axios.patch('/api/v1/users/resetPassword', {resetToken, newPassword, newPasswordConfirm});
        if(data.status === 'success'){
            showAlert('success', 'Password resetted successfuly');
            setTimeout(() => window.location.assign('/') , 1200)
        }
    } catch (error) {
        showAlert('error', error.response.data.message)
    }
}